module.exports = __webpack_public_path__ + "static/media/fullCloud.447057c8.png";